
const firebaseConfig = {
  apiKey: "AIzaSyBNkcxdndVppncjDFydJUhewH4j53KaB9Q",
  authDomain: "samscrypto-19fe2.firebaseapp.com",
  projectId: "samscrypto-19fe2",
  storageBucket: "samscrypto-19fe2.appspot.com",
  messagingSenderId: "192489444770",
  appId: "1:192489444770:web:bf749a8ac5026e6e5f8efb",
  measurementId: "G-28NRD3HZ35"
};


export default firebaseConfig;
